var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.5rem",
    height: "1.5rem",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9 11.1375C13.2041 11.1375 19.8 12.7957 19.8 16.0875V19.8H0V16.0875C0 12.7957 6.59587 11.1375 9.9 11.1375ZM9.9 0C11.2128 0 12.4719 0.521516 13.4002 1.44982C14.3285 2.37813 14.85 3.63718 14.85 4.95C14.85 6.26282 14.3285 7.52187 13.4002 8.45018C12.4719 9.37848 11.2128 9.9 9.9 9.9C8.58718 9.9 7.32813 9.37848 6.39982 8.45018C5.47152 7.52187 4.95 6.26282 4.95 4.95C4.95 3.63718 5.47152 2.37813 6.39982 1.44982C7.32813 0.521516 8.58718 0 9.9 0ZM9.9 13.4887C6.22462 13.4887 2.35125 15.2955 2.35125 16.0875V17.4488H17.4488V16.0875C17.4488 15.2955 13.5754 13.4887 9.9 13.4887ZM9.9 2.35125C9.21077 2.35125 8.54977 2.62505 8.06241 3.11241C7.57505 3.59977 7.30125 4.26077 7.30125 4.95C7.30125 5.63923 7.57505 6.30023 8.06241 6.78759C8.54977 7.27495 9.21077 7.54875 9.9 7.54875C10.5892 7.54875 11.2502 7.27495 11.7376 6.78759C12.225 6.30023 12.4988 5.63923 12.4988 4.95C12.4988 4.26077 12.225 3.59977 11.7376 3.11241C11.2502 2.62505 10.5892 2.35125 9.9 2.35125Z",
    fill: "#2E0052"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.49f41930b119d6f360ead0c20ed07e0a.svg";
export { ForwardRef as ReactComponent };